import { useRef, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { equipmentApi } from '@entities/equipment';

export const useEquipmentPage = () => {
    const [filterValue, setFilterValue] = useState('');
    const hasFinishedInitialLoadRef = useRef(false);
    const equipmentDataQuery = useQuery(equipmentApi.getEquipmentDataQueryOptions());
    const totalInfoQuery = useQuery(equipmentApi.getTotalInfoQueryOptions());
    const equipmentData = equipmentDataQuery.data;
    const hasFullAccess = equipmentData?.restrictions.hasFullAccess ?? false;
    const availableProjectsQuery = useQuery({
        ...equipmentApi.getAvailableProjectsQueryOptions(),
        enabled: equipmentDataQuery.isSuccess && hasFullAccess,
    });
    const areInitialQueriesPending =
        equipmentDataQuery.isPending ||
        totalInfoQuery.isPending ||
        (hasFullAccess && availableProjectsQuery.isPending);

    if (!areInitialQueriesPending) {
        hasFinishedInitialLoadRef.current = true;
    }

    return {
        filterValue,
        setFilterValue,
        isInitialLoading: !hasFinishedInitialLoadRef.current && areInitialQueriesPending,
    };
};
